import React from 'react';

const ImportTeamsSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">


      {/* Teams list skeleton */}
      <div className="space-y-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="bg-secondary-light border mt-6 border-gray-200 rounded-lg dark:bg-secondary-dark dark:border-gray-700">
            <div className="py-5 px-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
             
                  <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse"></div>
                  <div>
                    <div className="w-32 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-2"></div>
                    <div className="w-24 h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-14 h-7 bg-gray-200 mr-3 dark:bg-gray-700 rounded-lg animate-pulse"></div>
                  <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                </div>
              </div>
            </div>
            
        
           
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImportTeamsSkeleton;
